import { render, staticRenderFns } from "./ContactDetailsSection.vue?vue&type=template&id=18159865"
import script from "./ContactDetailsSection.vue?vue&type=script&lang=ts"
export * from "./ContactDetailsSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports